import './MobSplash.css';

interface MobSplashProps {
  label?: string;
}

export function MobSplash({ label = 'Loading…' }: MobSplashProps) {
  return (
    <div className="mob-splash" role="status" aria-live="polite">
      <div className="mob-splash__spinner" aria-hidden="true" />
      <div className="mob-splash__label">{label}</div>
    </div>
  );
}
